








































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class GenericTable extends Vue {
    @Prop() public title!: string;
    @Prop() public icon: string = 'mdi-table';
    @Prop() public items: any[] = [];
    @Prop() public headers: any[] = [];
    @Prop() public loading: boolean = false;
}
